import {
    AMPPA_AUTH,
    API_REQUEST,
    CHECK_PASSWORD,
    CHECK_USERNAME,
    LOGIN_AUTH,
    ROLL_AUTH
} from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";

// Example login action
export const login = (formdata: Record<string, unknown>): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/sign-in`,
        next: LOGIN_AUTH,
        method: 'POST',
        data: formdata
    }
});

export const amppaAuth = (formdata: Record<string, unknown>): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/user/amppa/login`,
        next: AMPPA_AUTH,
        method: 'POST',
        data: formdata
    }
});

interface RollAccessKeyPayload extends Record<string, unknown> {
    rollNumber: string;
    accessKey: string;
}

// Example readToken action
export const loginRegisterRoll = (formdata: RollAccessKeyPayload): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/verify-roll`,
        next: ROLL_AUTH,
        method: 'POST',
        data: formdata
    }
});

export const checkUserName = (username: string): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/user/check-user/`,
        next: CHECK_USERNAME,
        method: 'POST',
        data: {
            "user_id": username
        }
    }
})

export const checkPassword = (password: string): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/user/check-pass/`,
        next: CHECK_PASSWORD,
        method: 'POST',
        data: {
            "pwd": password
        }
    }
})

